import * as types from './types';

const acceptAgeCheck = () => ({
  type: types.ACCEPT_AGE_CHECK,
  data: true,
});

export {
  acceptAgeCheck
};